import { useTranslation } from 'react-i18next'
import { Radio } from 'antd'
import { AccessToLearningProgramsEnum } from 'enum/accessToLearningPrograms'
import { Wrapper, Option, Title, Subtitle } from './styled'

interface IProps {
  activeOption: AccessToLearningProgramsEnum
  changeOption: (value: AccessToLearningProgramsEnum) => void
}

const Options = ({ activeOption, changeOption }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.form.addLearningPrograms.options'

  return (
    <Wrapper>
      <div>
        <Option
          activeOption={activeOption === AccessToLearningProgramsEnum.None}
          onClick={() => changeOption(AccessToLearningProgramsEnum.None)}
        >
          <Radio checked={activeOption === AccessToLearningProgramsEnum.None} />
          <Title>{t(`${prefix}.none.title`)}</Title>
          <Subtitle>{t(`${prefix}.none.description`)}</Subtitle>
        </Option>
      </div>
      <div>
        <Option
          activeOption={activeOption === AccessToLearningProgramsEnum.All}
          onClick={() => changeOption(AccessToLearningProgramsEnum.All)}
        >
          <Radio checked={activeOption === AccessToLearningProgramsEnum.All} />
          <Title>{t(`${prefix}.all.title`)}</Title>
          <Subtitle>{t(`${prefix}.all.description`)}</Subtitle>
        </Option>
      </div>
      <div>
        <Option
          activeOption={activeOption === AccessToLearningProgramsEnum.Specific}
          onClick={() => changeOption(AccessToLearningProgramsEnum.Specific)}
        >
          <Radio
            checked={activeOption === AccessToLearningProgramsEnum.Specific}
          />
          <Title>{t(`${prefix}.specific.title`)}</Title>
          <Subtitle>{t(`${prefix}.specific.description`)}</Subtitle>
        </Option>
      </div>
    </Wrapper>
  )
}

export default Options
